const prefetchedKeys = new Set();

const runWhenIdle = (cb) => {
  if (typeof window === "undefined") return;
  if (typeof window.requestIdleCallback === "function") {
    window.requestIdleCallback(cb, { timeout: 1500 });
    return;
  }
  setTimeout(cb, 300);
};

const prefetchOnce = (key, fn) => {
  if (prefetchedKeys.has(key)) return;
  prefetchedKeys.add(key);
  runWhenIdle(() => {
    try {
      fn();
    } catch (e) {
      // Prefetch is best-effort only.
    }
  });
};

export const prefetchAfterLoginIdle = () => {
  // 3–5 most-used routes first
  prefetchOnce("prefetch-dashboard", () =>
    import("../Pages/Dashboard/Dashboard"),
  );
  prefetchOnce("prefetch-crm", () => import("../Pages/Crm/CrmList"));
  //prefetchOnce("prefetch-jobs", () =>
  //  import("../Pages/ProjectManagement/ProjectManagement"),
  //);
  prefetchOnce("prefetch-marketing-list", () =>
    import("../Routes/groups/MarketingRoutes"),
  );
  prefetchOnce("prefetch-schedule-list", () =>
    import("../Routes/groups/ScheduleRoutes"),
  );
};

export const prefetchMarketingRoutes = () =>
  prefetchOnce("prefetch-marketing-group", () =>
    import("../Routes/groups/MarketingRoutes"),
  );

export const prefetchAutomationRoutes = () =>
  prefetchOnce("prefetch-automation-group", () =>
    import("../Routes/groups/AutomationRoutes"),
  );

export const prefetchScheduleRoutes = () =>
  prefetchOnce("prefetch-schedule-group", () =>
    import("../Routes/groups/ScheduleRoutes"),
  );

export const prefetchBuilderRoutes = () =>
  prefetchOnce("prefetch-builder-group", () =>
    import("../Routes/groups/BuilderRoutes"),
  );
